import * as Yup from 'yup'

export const getValidationSchema = () =>
  Yup.object().shape({
    supportCode: Yup.string()
      .matches(/^[A-Za-z0-9]+$/, "Cod invalid pentru suport")
    .required('Cod suport este un câmp obligatoriu')
  })

export const initialValues = {
  supportCode: ''
}
